export default "__VITE_ASSET__BjvGFfQ5__"